import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-soft-blue via-white to-soft-blue">
      {/* pt-24 clears the fixed header, matching About/FAQ. */}
      <div className="max-w-4xl mx-auto px-4 pt-24 pb-16">
        <h1 className="text-4xl font-bold text-karvlo-navy mb-8">Privacy Policy</h1>
        <p className="text-karvlo-gray mb-6">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

        <div className="space-y-8 text-karvlo-gray leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">1. Information We Collect</h2>
            <p>When you use Karvlo, we collect information to provide and improve our ride-hailing services:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Account information:</strong> Name, email, phone number, and profile photo</li>
              <li><strong>Location data:</strong> Pickup and destination locations, GPS coordinates during rides</li>
              <li><strong>Payment information:</strong> Payment method details processed securely via Stripe</li>
              <li><strong>Device information:</strong> Device type, operating system, and browser type</li>
              <li><strong>Usage data:</strong> Ride history, ratings, and app usage patterns</li>
              <li><strong>Driver documents:</strong> HKID, vehicle registration, and insurance for verification</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">2. How We Use Your Information</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Match riders with nearby drivers and provide ride services</li>
              <li>Process payments and calculate fares</li>
              <li>Communicate ride updates and support messages</li>
              <li>Ensure safety through driver verification and ride monitoring</li>
              <li>Improve our service through analytics and feedback</li>
              <li>Send important service updates and notifications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">3. Data Sharing</h2>
            <p>We share limited information only when necessary:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li><strong>Between riders and drivers:</strong> Name, phone, vehicle info, and location during rides</li>
              <li><strong>Payment processors:</strong> Stripe handles all payment data securely</li>
              <li><strong>Legal requirements:</strong> When required by law or to protect safety</li>
            </ul>
            <p className="mt-2">We never sell your personal data to third parties.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">4. Data Security</h2>
            <p>We protect your data using industry-standard security measures including encryption in transit (HTTPS/TLS), secure token-based authentication (JWT), and encrypted storage for sensitive documents.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">5. Your Rights</h2>
            <p>Under Hong Kong's Personal Data (Privacy) Ordinance (PDPO), you have the right to:</p>
            <ul className="list-disc ml-6 mt-2 space-y-1">
              <li>Access your personal data</li>
              <li>Request correction of inaccurate data</li>
              <li>Delete your account (which anonymizes your personal data)</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">6. Data Retention</h2>
            <p>We retain your data for as long as your account is active. When you delete your account, we anonymize your personal information. Ride history and transaction records are retained for legal and accounting purposes for 7 years.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-karvlo-navy mb-3">7. Contact Us</h2>
            <p>For privacy inquiries, contact us at <a href="mailto:privacy@karvlo.com" className="text-karvlo-blue hover:underline">privacy@karvlo.com</a> or <a href="mailto:support@karvlo.com" className="text-karvlo-blue hover:underline">support@karvlo.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
